module.exports = {
    advanceSearch: {
        en: "Advanced search",
        fi: "Edistynyt haku"
    },
    stores: {
        en: "Stores",
        fi: "Kaupat"
    },
    account: {
        en: "Account",
        fi: "Tili"
    },
    createPost: {
        en: "Create post",
        fi: "Luo ilmoitus"
    },
    hi: {
        en: "Hi,",
        fi: "Hei,"
    },
    profile: {
        en: "Profile",
        fi: "Profiili"
    },
    logOut: {
        en: "Log out",
        fi: "Kirjaudu ulos"
    },
    logIn: {
        en: "Log in",
        fi: "Kirjaudu sisään"
    }
};